"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showSnack = exports.dismissSnack = exports.REMOVE_SNACK = exports.ADD_SNACK = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ADD_SNACK = exports.ADD_SNACK = 'ADD_SNACK';
var REMOVE_SNACK = exports.REMOVE_SNACK = 'REMOVE_SNACK';
var showSnack = exports.showSnack = function showSnack(payload) {
  return function (dispatch, getState) {
    var _getState = getState(),
      snackbar = _getState.snackbar;
    var snacks = snackbar.snacks;
    var snack = payload;
    if (!payload.text || payload.text.length === 0) {
      // this is not a tasty snack!
      console.log(payload);
      return;
    }
    if (snacks.length !== 0) {
      var _snack = snacks.find(function (snack) {
        return snack.id === payload.id;
      });
      // Below prevents duplicate snackbars for same snack id. Makes exception for order cancelations due to account liquidations
      if (_snack && (payload.id !== 'MarginCancelOrderAccountLiquidation' || payload.id !== 'MarginCall')) {
        _snack.count ? _snack.count++ : _snack.count = 2;
        _snack.text = "".concat(payload.text, " (").concat(_snack.count.toString(), ")");
        dispatch(dismissSnack(_snack.uniqueId));
      }
    }
    dispatch(addSnack(snack));
  };
};
var dismissSnack = exports.dismissSnack = function dismissSnack(uniqueId) {
  return {
    type: REMOVE_SNACK,
    payload: uniqueId
  };
};
var addSnack = function addSnack(payload) {
  return {
    type: ADD_SNACK,
    payload: _objectSpread(_objectSpread({}, payload), {}, {
      uniqueId: Date.now()
    })
  };
};